import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AdminProfile {
  adminId: number;
  username: string;
  name: string;
}

interface AuthState {
  token: string | null;
  profile: AdminProfile | null;
  setAuth: (token: string, profile: AdminProfile) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      profile: null,
      setAuth: (token, profile) => set({ token, profile }),
      clear: () => set({ token: null, profile: null }),
    }),
    { name: 'tg-platform-auth' },
  ),
);
